import axios from 'axios';
import {getToken} from '../utils/auth';
import router from "@/router/index";
import {Notify} from 'vant'
// import env from '../../env'
import {config} from '../../config'

console.log('--baseURL 111',process.env);
console.log('--baseURL 222',config.baseURL);

// 创建axios实例
let service = axios.create({
    //baseURL: 'https://www.easy-mock.com/mock/5c46e24769e1dd2d0053e4d8/base', // api的base_url
    // baseURL: '/home', // api的base_url
    timeout: 50000, // 请求超时时间
    // baseURL: '/wsbq/',
    // baseURL: '/ceshi/wsbq/'
   // baseURL: config.baseURL + '/wsbq/'
   baseURL: 'https://baoquan.court.gov.cn' + '/wsbq/'
})

// request拦截器
service.interceptors.request.use(config => {
    // loadObj = Loading.service({
    //     lock: true,
    //     text: '加载中……',
    //     background: 'rgba(0, 0, 0, 0.7)'
    // });
    let token = getToken();
    if (token != undefined && token != "undefined") {
        config.headers = {
            'Bearer': getToken(), //携带权限参数
        };
    }
    return config
}, error => {
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        if (res.code === 401 || res.code === 50008 || res.code === 50012 || res.code === 50014) {
            let logStatus = window.sessionStorage.getItem("logSource")
            if(logStatus == 1){
                Notify({
                    message: '登录已过期，请从移动微法院重新登录',
                    type: 'danger',
                    duration: 5 * 1000
                })
            }else{
                Notify({
                    message: '登录已过期，请重新登录',
                    type: 'danger',
                    duration: 5 * 1000
                })
                // router.push("/login")
            }
        }
        return response.data;
    },
    error => {
        console.log("error=====",error)
        if (error.response.data.status === 50014) {
            let logStatus = window.sessionStorage.getItem("logSource")
            if(logStatus == 1){
                Notify({
                    message: '登录已过期，请从移动微法院重新进入',
                    type: 'danger',
                    duration: 5 * 1000
                })
            }else{
                Notify({
                    message: '登录已过期，请重新登录',
                    type: 'danger',
                    duration: 5 * 1000
                })
                // router.push("/login")
            }
            // store.dispatch('logout').then(() => {
            //     location.reload()
            // })
            // router.push("/ali_login")
        } else {
            let message = error.response.data.message ? error.response.data.message : '系统异常'
            Notify({
                message:message,
                type: 'danger',
                duration: 5 * 1000
            })
        }
        return Promise.reject(error)
    }
)

export default service
